<template>
    <component :is="$auth.isSubdomainActive() ? 'div' : 'common-page-plain'">
        <common-content-wrapper width="medium">
            <div v-if="offer && allowRating">
                <common-content-spacer height="medium" class="rate">
                    <common-content-spacer class="rate--offer" height="medium">
                        <common-page-header
                            size="large"
                            :heading="getTranslation(offer?.availabilityOffer?.linkedOffer.titleTextContent)"
                            :isCenter="true"
                        ></common-page-header>
                        <img class="rate--offer__throphy" :src="throphyImage" :alt="$t('alt.rating_trophy')" />
                        <p class="rate--offer__title">{{ $t('pages.rating.rate.rating.please_rate') }}</p>
                        <div class="rate--offer__images">
                            <img :src="getUserImage" :alt="$t('alt.user_image')" />
                            <p>
                                <span class="rate--offer__dot"></span>
                                <span class="rate--offer__dot"></span>
                                <span class="rate--offer__dot"></span>
                            </p>
                            <img :src="getOfferImage" :alt="$t('alt.offer_image')" />
                        </div>
                    </common-content-spacer>
                    <div class="rate--wrapper">
                        <rating-enter :showTextGrade="false" @rated="rated"></rating-enter>
                    </div>

                    <textarea-input
                        :label="$t('pages.rating.rate.rating.comment.label')"
                        :placeholder="$t('pages.rating.rate.rating.comment.placeholder')"
                        @change="changeComment"
                    ></textarea-input>
                    <common-buttons>
                        <common-button
                            :isSubmittable="false"
                            type="primary"
                            :isDisabled="!ratingScore"
                            :label="$t('common.microcopy.save')"
                            @click="submitRating"
                        ></common-button>
                    </common-buttons>
                </common-content-spacer>
            </div>
            <div v-else-if="showGoogleBuissnes">
                <common-content-spacer class="rate--offer" height="medium">
                    <common-page-header
                        size="large"
                        :heading="getTranslation(offer?.availabilityOffer?.linkedOffer?.titleTextContent)"
                        :isCenter="true"
                    ></common-page-header>
                    <p class="rate--offer__title--google">{{ $t('pages.rating.rate.rating.google_rate') }}</p>

                    <common-buttons>
                        <common-button
                            :isSubmittable="false"
                            type="secondary"
                            :label="$t('common.microcopy.dont_want')"
                            @click="goToHomePage()"
                        ></common-button>
                        <common-button
                            :isSubmittable="false"
                            type="primary"
                            :isDisabled="!ratingScore"
                            :label="$t('common.microcopy.i_want')"
                            @click="goToGoogleBusiness()"
                        ></common-button>
                    </common-buttons>
                </common-content-spacer>
            </div>
        </common-content-wrapper>
    </component>
</template>

<script>
    import RatingAPI from 'api/RatingAPI'
    import RatingEnter from 'components/page-elements/rating/RatingEnter'
    import FormMixin from 'mixins/FormMixin'
    import RoutesEnum from 'enums/routes.enum'
    import TranslateMixin from 'mixins/TranslateMixin'

    export default {
        mixins: [FormMixin, TranslateMixin],
        components: { RatingEnter },

        data() {
            return {
                offer: null,
                ratingScore: null,
                comment: null,
                throphyImage: require('../../assets/images/throphy-gold.png'),
                placeholderImage: require('../../assets/images/user-placeholder.png'),
                placeholderOfferImage: require('../../assets/images/offer-placeholder.png'),
                allowRating: true,
            }
        },

        computed: {
            getUserImage() {
                return this.$auth.getUser().photoMain || this.placeholderImage
            },

            getOfferImage() {
                return this.offer?.availabilityOffer?.linkedOffer.photoThumbnail || this.placeholderOfferImage
            },
        },

        methods: {
            showGoogleBuissnes() {
                return (
                    !this.allowRating &&
                    this.offer?.availabilityOffer?.linkedOffer?.location?.companyServiceProvider &&
                    this.offer?.availabilityOffer?.linkedOffer?.location?.googleBusiness
                )
            },

            getOfferByToken() {
                RatingAPI.getOfferByToken(this.$route.query.token)
                    .then((response) => {
                        this.offer = response
                    })
                    .catch((error) => {
                        if (error.error?.message === 'RATING.ALREADY_RATED') {
                            this.$toast.error(this.$t('validations.RATING.ALREADY_RATED'))
                            this.goToHomePage()
                        } else if (error.error?.message === 'TOKEN.EXPIRED') {
                            this.$toast.error(this.$t('validations.RATING.TOKEN_EXPIRED'))
                            this.goToHomePage()
                        } else {
                            this.$toast.error(this.$t('common.errors.common_error'))
                        }
                    })
            },

            goToHomePage() {
                this.$router.push({ name: RoutesEnum.INDEX.HOME })
            },

            goToGoogleBusiness() {
                window.open(this.offer?.availabilityOffer?.linkedOffer?.location?.googleBusiness, '_blank')
                this.goToHomePage()
            },

            rated(payload) {
                this.ratingScore = payload
            },

            changeComment({ value }) {
                if (value === undefined) {
                    return
                }

                this.comment = value
            },

            submitRating() {
                const request = {
                    comment: this.comment,
                    calendarEventId: this.offer.id,
                    ratingScore: this.ratingScore,
                }

                RatingAPI.rateOffer(request)
                    .then(() => {
                        this.$toast.success(this.$t('common.microcopy.success'))
                        if (
                            request.ratingScore === 5 &&
                            this.offer?.availabilityOffer?.linkedOffer?.location?.companyServiceProvider &&
                            this.offer?.availabilityOffer?.linkedOffer?.location?.googleBusiness
                        ) {
                            this.allowRating = false
                        } else {
                            this.goToHomePage()
                        }
                    })
                    .catch(() => {
                        this.$toast.error(this.$t('common.errors.common_error'))
                    })
            },
        },

        mounted() {
            this.getOfferByToken()
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';
    .rate {
        &--offer {
            margin-top: 50px;
            text-align: center;

            &__throphy {
                border-radius: 50%;
                width: 200px;
            }

            &__title {
                color: $color--txt-base;
                font-weight: 600;
                font-size: $font-size--heading-small;
                line-height: 18px;
                height: 36px;
                overflow: hidden;
                text-overflow: ellipsis;
                &--google {
                    height: 100%;
                    font-weight: 600;
                    font-size: $font-size--heading-smaller;
                }
            }

            &__images {
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                    width: 90px;
                    height: 90px;
                    margin: 0 20px;
                    border-radius: 50%;
                    border: 4px solid $color--accent-1;
                }
            }
            &__dot {
                height: 15px;
                width: 15px;
                background-color: $color--accent-1;
                border-radius: 50%;
                display: inline-block;
                margin: 0 5px;
            }
        }
        &--wrapper {
            margin-top: 20px;
            text-align: center;
        }
    }

    .subdomain-layout {
        &--navy_black,
        &--black {
            .rate {
                &--offer {
                    &__images {
                        img {
                            border: 4px solid $subdomain-blue;
                        }
                    }

                    &__dot {
                        background-color: $subdomain-blue;
                    }
                }
            }
        }
    }
</style>
